<span class="td-wb-w8ben-form-tooltip__container">&nbsp;
  <button id="td-wb-w8ben-tooltip-button"
          class="td-wb-w8ben-form-tooltip__link"
          tdWbButton
          tdWbButtonType="icon"
          tdWbButtonSize="inline"
          [tdWbOverlayToggle]="w8BenTooltipTemplate"
          tdWbOverlayPosition="center-right"
          tdWbOverlaySize="small"
          [attr.aria-label]="('tdWb.w8BenForm.modal.common.HELP' | tdWbTranslate)">
    <td-wb-icon iconId="tooltip--small"
                size="14" />
  </button>
</span>
<ng-template #w8BenTooltipTemplate>
  <td-wb-overlay class="td-wb-w8ben-form-tooltip__overlay">
    <ng-content />
  </td-wb-overlay>
</ng-template>
